import { graphql } from "@opensea/graphql"
import { TransferFlowFormItemFragment } from "../TransferFlowFormItem/TransferFlowFormItem.fragment"

export const TransferFlowForm_itemFragment = graphql(
  `
    fragment TransferFlowForm_item on Item {
      id
      ...TransferFlowFormItem_item
      ownership(address: $address) {
        quantity
      }
    }
  `,
  [TransferFlowFormItemFragment],
)
